module.exports = __webpack_public_path__ + "static/media/loc6_img5.8e61e7b7.jpg";